<script setup lang="ts">
import Toast from 'primevue/toast'
import { onMounted } from 'vue'

import ChatNoticeAlert from '@/components/chat/ChatNoticeAlert.vue'
import LocationSheet from '@/components/location/LocationSheet.vue'
import OrderNoticeSheet from '@/components/order/OrderNoticeSheet.vue'
import { useAppBootstrap } from '@/composables/useAppBootstrap'
import { useBackNavigation } from '@/composables/useBackNavigation'
import { useChatDeeplink } from '@/composables/useChatDeeplink'
import { SHOW_SUPPORT_CHAT } from '@/constants/features'
import { useKeyboardDismiss } from '@/composables/useKeyboardDismiss'
import { useKeyboardScroll } from '@/composables/useKeyboardScroll'
import { useTelegram } from '@/composables/useTelegram'
import { useLocationStore } from '@/stores/location'

/** Тост во всю ширину экрана минус поля: длинные сообщения иначе рвутся по два слова. */
const TOAST_STYLE = {
  left: 'var(--screen-padding)',
  right: 'var(--screen-padding)',
  width: 'auto',
  maxWidth: 'var(--app-max-width)',
  margin: '0 auto',
  transform: 'none',
}

const locationStore = useLocationStore()

const { init } = useTelegram()
const { bootstrap } = useAppBootstrap()
const { follow } = useChatDeeplink()

/* Тап мимо поля закрывает клавиатуру — в Telegram на iOS сама она не прячется */
useKeyboardDismiss()

/* И поднимаем поле над клавиатурой: сама страница под ней не сжимается */
useKeyboardScroll()

/* Кнопка «назад» Telegram и свайп от левого края вместо выхода из мини-аппа */
useBackNavigation()

onMounted(() => {
  init()
  // Меню тянем на старте: с товарами работают корзина, избранное и шит
  void bootstrap()
  /* Параметр запуска читаем после init: до него Telegram.WebApp ещё не наш */
  if (SHOW_SUPPORT_CHAT) void follow()
})
</script>

<template>
  <RouterView v-slot="{ Component }">
    <component :is="Component" />
  </RouterView>
  <!-- Позицию PrimeVue пишет инлайном (left: 50%), поэтому ширину задаём через pt -->
  <Toast position="bottom-center" :pt="{ root: { style: TOAST_STYLE } }" />
  <!-- Ответ поддержки виден на любом экране и ведёт прямо в переписку -->
  <ChatNoticeAlert v-if="SHOW_SUPPORT_CHAT" />
  <!-- Смена статуса заказа: карточка поверх того экрана, где застала клиента -->
  <OrderNoticeSheet />
  <!--
    Выбор точки здесь, а не на главной: его открывает и «плюс» в меню, и
    избранное, и корзина — везде, где клиент берёт товар без выбранного адреса.
  -->
  <LocationSheet
    v-model:visible="locationStore.isPickerOpen"
    :order-type="locationStore.pickerType"
    :with-saved="locationStore.isPickerSaved"
  />
</template>
